// Third-party
import React from 'react';

// Utils
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { enumerateJSX, truncateString } from '../../../../utils/objects';
import { COMPARISON_ITEM_TYPES } from '../../../../utils/constants';
import { HoldingIcon } from '../../common';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import LocalizedString from '@/types/localized-string';
import ComparisonItemType from '@/types/comparison-item-type';

interface Props {
  items: ComparisonItem[];
  locale?: Locale;
  benchmarksBreakdownDisclaimers?: LocalizedString;
}

const BenchmarksBreakdownDisclaimer = ({ items, locale, benchmarksBreakdownDisclaimers }: Props) => {
  if (benchmarksBreakdownDisclaimers == null) {
    return null;
  }

  const benchmarks = items.filter(item => item.type === COMPARISON_ITEM_TYPES.BENCHMARK);

  const getHoldingIcon = (type: ComparisonItemType, color?: string) => (!color ? null : <HoldingIcon type={type} color={color} />);

  const getNameElement = (item: ComparisonItem) => {
    const name: string | undefined = item.name[locale!];
    let label = truncateString(name != null ? name : '', 40);

    if (item.type !== COMPARISON_ITEM_TYPES.PORTFOLIO && item.holdings[0].symbol) {
      label = item.holdings[0].symbol;
    }

    return (
      <span key={item._id} className="item-name" data-private data-dd-privacy="mask">
        {getHoldingIcon(item.type, item.color)}
        {label}
      </span>
    );
  };

  return (
    <span className="disclaimer">
      {formatMessageWithLocale('Disclaimers.CustomDisclaimer.Short.Prefix', locale)}
      {enumerateJSX(benchmarks.map(getNameElement), formatMessageWithLocale('Common.And', locale))}
      {formatMessageWithLocale('Disclaimers.CustomDisclaimer.Short.Suffix', locale)}
    </span>
  );
};

export default BenchmarksBreakdownDisclaimer;
